/**
 * 图片转文本结果中的图片项
 */
export interface ImageToTextImageItem {
    /** 存储 URL */
    stored_url: string;
    /** 签名 URL（可选） */
    signed_url?: string;
    /** 图片转文本结果（可选） */
    image_to_text?: string;
    /** 文件大小（字节） */
    file_size?: number;
}

/**
 * 图片转文本结果中的文件项
 */
export interface ImageToTextFileItem {
    /** 原始文件名 */
    original_file_name?: string;
    /** 存储 URL */
    stored_url: string;
    /** 签名 URL（可选） */
    signed_url?: string;
    /** 文件大小（字节） */
    file_size?: number;
}

/**
 * 图片转文本模型类型
 */
export type ImageToTextModelType = 'qwen-2_5' | 'gemini-2.5-flash' | 'qwen-vl-max';

/**
 * 图片转文本结果
 */
export interface ImageToTextResult {
    /** 模型类型，默认值为 qwen-2_5 */
    model_type?: ImageToTextModelType;
    /** 转换后的文本（可选） */
    text?: string;
    /** 图片列表（必选） */
    images: ImageToTextImageItem[];
    /** 文件列表（可选） */
    files?: ImageToTextFileItem[];
}

export interface CreateNoveltyCheckTaskRequest {
    input: string;
    task_id: string;
    pbd_start?: string;
    pbd_end?: string;
    /**
     * 小语种翻译后的文本（可选）
     * 当用户输入为小语种时，此字段包含翻译后的文本
     */
    translation_input?: string;
    /**
     * 图片转文本结果（可选）
     * 当用户上传图片进行识别时，此字段包含识别结果
     */
    image_to_text_result?: ImageToTextResult;
}

export type CreateNoveltyCheckTaskResponse = {
    task_id: string;
    text: string;
};

/**
 * 创建查新任务 API
 */
export interface CreateNoveltyCheckTaskApi {
    /**
     * 创建查新任务
     * @param data 创建查新任务请求
     * @returns 创建查新任务响应
     */
    createNoveltyCheckTask(data: CreateNoveltyCheckTaskRequest): Promise<CreateNoveltyCheckTaskResponse>;
}

export const CreateNoveltyCheckTaskApi = Symbol.for('CreateNoveltyCheckTaskApi');
